import { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { notifications } from "@mantine/notifications";
import { editStatus } from "../../../../../api/PRMAPI";
import { ActionIcon, Button, ColorInput, Group, Tooltip } from "@mantine/core";
import { IconDeviceFloppy, IconPalette } from "@tabler/icons-react";
import PopOver from "../../../../../components/View/PopOver";

const EditStatusColor = ({
  id,
  statusColor,
  handleRefresh,
  disabled,
  inColumn,
}) => {
  const lang = useLanguage((s) => s.language);
  const [color, setColor] = useState(
    statusColor ? "#" + statusColor : "#333333"
  );
  const [loading, setLoading] = useState(false);

  const handleEdit = (handleClose) => {
    setLoading(true);
    editStatus({
      id,
      color: color.substring(1),
      isSystem: typeof id === "string",
    })
      .then((r) => {
        notifications.show({
          message: lang.prm.status.edited,
          color: "tertiary.8",
        });
        handleClose();
        handleRefresh("color", color.substring(1));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (inColumn) {
    return (
      <PopOver
        opener={(handleOpen, ref) =>
          inColumn ? (
            <Button
              ref={ref}
              onClick={handleOpen}
              w={"100%"}
              justify="start"
              variant="subtle"
              color="black"
              px={11}
            >
              <Group gap={"xs"}>
                <IconPalette size={16} />
                <span>{lang.prm.status.color}</span>
              </Group>
            </Button>
          ) : (
            <Tooltip label={lang.prm.status.color} disabled={disabled}>
              <ActionIcon
                ref={ref}
                onClick={handleOpen}
                disabled={disabled}
                size={"sm"}
                variant="light"
                color={"secondary"}
              >
                <IconPalette size={16} />
              </ActionIcon>
            </Tooltip>
          )
        }
        popoverChildren={(handleClose) => (
          <Group align="start">
            <ColorInput
              label={lang.prm.status.color}
              placeholder={lang.prm.status.color}
              required
              value={color}
              onChange={setColor}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleEdit(handleClose);
                }
              }}
              format="hex"
              w={160}
              popoverProps={{
                zIndex: 1500,
                withinPortal: false,
                opened: true,
                keepMounted: true,
              }}
              closeOnColorSwatchClick={true}
              withPicker={!inColumn}
              swatches={[
                "#2e2e2e",
                "#868e96",
                "#fa5252",
                "#e64980",
                "#be4bdb",
                "#7950f2",
                "#4c6ef5",
                "#228be6",
                "#15aabf",
                "#12b886",
                "#40c057",
                "#82c91e",
                "#fab005",
                "#fd7e14",
              ]}
              styles={{
                dropdown: {
                  width: 144,
                  display: "flex",
                  padding: "0 4px",
                },
                swatches: {
                  position: "static",
                },
              }}
            />
            <Button
              leftSection={<IconDeviceFloppy size={16} />}
              onClick={() => handleEdit(handleClose)}
              loading={loading}
              mt={56}
              w={"100%"}
            >
              {lang.global.save}
            </Button>
          </Group>
        )}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        transformOrigin={{ horizontal: "center", vertical: "top" }}
        disablePortal={inColumn}
        anchorPosition={inColumn ? { left: 0, top: 120 } : undefined}
        anchorReference={inColumn ? "anchorPosition" : undefined}
        paperSx={{ maxHeight: 320 }}
      />
    );
  }

  return (
    <PopOver
      opener={(handleOpen, ref) =>
        inColumn ? (
          <Button
            ref={ref}
            onClick={handleOpen}
            w={"100%"}
            justify="start"
            variant="subtle"
            color="black"
            px={11}
          >
            <Group gap={"xs"}>
              <IconPalette size={16} />
              <span>{lang.prm.status.color}</span>
            </Group>
          </Button>
        ) : (
          <Tooltip label={lang.prm.status.color} disabled={disabled}>
            <ActionIcon
              ref={ref}
              onClick={handleOpen}
              disabled={disabled}
              size={"sm"}
              variant="light"
              color={"secondary"}
            >
              <IconPalette size={16} />
            </ActionIcon>
          </Tooltip>
        )
      }
      popoverChildren={(handleClose) => (
        <Group align="end">
          <ColorInput
            label={lang.prm.status.color}
            placeholder={lang.prm.status.color}
            required
            value={color}
            onChange={setColor}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleEdit(handleClose);
              }
            }}
            format="hex"
            popoverProps={{ zIndex: 1500 }}
            closeOnColorSwatchClick={false}
            withPicker={!inColumn}
            swatches={
              inColumn
                ? []
                : [
                    "#2e2e2e",
                    "#868e96",
                    "#fa5252",
                    "#e64980",
                    "#be4bdb",
                    "#7950f2",
                    "#4c6ef5",
                    "#228be6",
                    "#15aabf",
                    "#12b886",
                    "#40c057",
                    "#82c91e",
                    "#fab005",
                    "#fd7e14",
                  ]
            }
          />
          <ActionIcon
            onClick={() => handleEdit(handleClose)}
            loading={loading}
            size={"lg"}
          >
            <IconDeviceFloppy size={18} />
          </ActionIcon>
        </Group>
      )}
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      transformOrigin={{ horizontal: "center", vertical: "top" }}
      disablePortal={inColumn}
    />
  );
};

export default EditStatusColor;
